import * as Styled from './styled'

const LoadingSkeleton = ({
  width,
  className = ''
}: {
  width?: number
  className?: string
}) => {
  return <Styled.LoadingSkeleton $width={width} className={className} />
}

export default LoadingSkeleton
